import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg, fmtDateTime } from "../../lib/api";
import { PageHeader, TableShell, TR, TD, LoadingRows, EmptyState } from "../../components/Shared";

const Badge = ({ v, testid }) => {
  const ok = ["connected", "verified", "active"].includes(v);
  const warn = ["pending", "waiting", "provisioning"].includes(v);
  return (
    <span data-testid={testid} className={`px-2.5 py-1 rounded-full text-[11px] font-extrabold ${ok ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400" : warn ? "bg-amber-500/10 text-amber-600 dark:text-amber-400" : "bg-muted text-muted-foreground"}`}>
      {v || "—"}
    </span>
  );
};

export default function RootDomains() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/root/domains").then((r) => setRows(r.data.domains)).catch((e) => toast.error(errMsg(e)));
  }, []);

  return (
    <div data-testid="root-domains-page">
      <PageHeader title="Custom Domains" subtitle="Read-only view — every custom domain mapped to its exact owner, store and website." testid="root-domains-title" />
      {!rows ? (
        <div className="bg-card border border-border rounded-2xl p-8"><LoadingRows rows={4} /></div>
      ) : rows.length === 0 ? (
        <EmptyState icon={Globe} title="No custom domains yet" body="When business owners connect domains, each mapping appears here." />
      ) : (
        <TableShell head={["Domain", "Owner", "Store / Website", "DNS", "SSL", "Status", "Connected Since"]} testid="domains-table">
          {rows.map((d) => (
            <TR key={d.domain} testid={`domain-row-${d.domain}`}>
              <TD className="font-mono font-bold">{d.domain}</TD>
              <TD><p className="font-semibold">{d.owner || "—"}</p><p className="text-xs text-muted-foreground">{d.owner_email}</p></TD>
              <TD><p className="font-semibold">{d.website}</p><p className="text-xs text-muted-foreground">/site/{d.slug}</p></TD>
              <TD><Badge v={d.dns_status} testid={`dns-${d.domain}`} /></TD>
              <TD><Badge v={d.ssl_status} testid={`ssl-${d.domain}`} /></TD>
              <TD><Badge v={d.status} testid={`status-${d.domain}`} /></TD>
              <TD className="text-sm text-muted-foreground">{d.connected_at ? fmtDateTime(d.connected_at) : "—"}</TD>
            </TR>
          ))}
        </TableShell>
      )}
    </div>
  );
}
